import CarouselWrapper from './CarouselWrapper';

export default CarouselWrapper;
